export var AddressBookNewGroupType;
(function (AddressBookNewGroupType) {
    AddressBookNewGroupType[AddressBookNewGroupType["SYSTEM"] = 0] = "SYSTEM";
    AddressBookNewGroupType[AddressBookNewGroupType["USER"] = 1] = "USER";
})(AddressBookNewGroupType || (AddressBookNewGroupType = {}));
